import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Api from '../../../util/api';
import { partial } from '../../../util/translation/translation';

const p = partial('auctionObjectsShared');

// The club's users blocked from bidding, and blocking/unblocking with a toast
const useBidderBlocking = () => {
  const [blockedUsers, setBlockedUsers] = useState([]);

  const fetchBlockedUsers = useCallback(async () => {
    try {
      setBlockedUsers(await Api.auctions.getBlockedBidders());
    } catch {
      setBlockedUsers([]);
    }
  }, []);

  useEffect(() => {
    fetchBlockedUsers();
  }, [fetchBlockedUsers]);

  const isBlocked = useCallback(
    (userId) => blockedUsers.some((user) => user.userId === userId),
    [blockedUsers]
  );

  const blockUser = async ({ userId, userName, reason, durationHours }) => {
    try {
      await Api.auctions.blockBidder({
        userId,
        userName,
        reason,
        durationHours,
      });
      toast.success(p('bidderBlocked', { name: userName || '' }));
    } catch (err) {
      toast.error(err || p('bidderBlockERROR'));
    } finally {
      fetchBlockedUsers();
    }
  };

  const unblockUser = async (userId) => {
    try {
      await Api.auctions.unblockBidder(userId);
      toast.success(p('bidderUnblocked'));
    } catch (err) {
      toast.error(err || p('bidderUnblockERROR'));
    } finally {
      fetchBlockedUsers();
    }
  };

  return { blockedUsers, isBlocked, blockUser, unblockUser, fetchBlockedUsers };
};

export default useBidderBlocking;
